import { Autocomplete, TextField, Typography } from '@mui/material';
import { ContactAssignmentTableEntity } from '../types';
import { Column } from 'react-table';
import { Nullable, SelectOption } from 'global';
import { LenderAssignmentTitles, UserProfile } from 'types';
import { LenderProfileAssignmentTitle } from '@trnsact/trnsact-shared-types';
import { keyBy } from 'utils/arrayUtils';

export const getContactAssignmentTableUserOptions = (contacts: UserProfile[]): SelectOption[] =>
  contacts.map(c => ({ value: c.id!, label: c.fullName! }));

export const createContactAssignmentTableColumns = (
  contactsOptions: SelectOption[],
  isUpsertLoading: boolean,
  onAssignmentChange: (userProfileId: Nullable<string>, assignment: ContactAssignmentTableEntity) => void
): Column<ContactAssignmentTableEntity>[] => [
  {
    resizable: false,
    sortable: false,
    Header: 'Assignment Title',
    headerClassName: 'customHeader',
    Cell: ({ original }) => (
      <Typography align="center" component="span" variant="body2">
        {original.title}
      </Typography>
    ),
  },
  {
    resizable: false,
    sortable: false,
    Header: 'Contact',
    headerClassName: 'customHeader',
    Cell: ({ original }) => (
      <Autocomplete
        disabled={isUpsertLoading}
        options={contactsOptions}
        sx={{ width: 300 }}
        value={contactsOptions.find((option: any) => option.value === original.userProfileId) ?? null}
        isOptionEqualToValue={(option, value) => option?.value === value?.value}
        onChange={(event, newValue: any) => onAssignmentChange(newValue?.value ?? null, original)}
        renderInput={params => <TextField {...params} label="Select Contact" variant="outlined" size="small" />}
        renderOption={(props, item) => (
          <li {...props} key={item.value}>
            <Typography>{item.label}</Typography>
          </li>
        )}
      />
    ),
  },
];

export const getDefaultContactAssignment = (
  title: LenderAssignmentTitles,
  lenderProfileId: string
): ContactAssignmentTableEntity => ({
  title,
  lenderProfileId,
  userProfileId: null,
});

export const formatSavedContactAssignment = (
  savedAssignment: LenderProfileAssignmentTitle
): ContactAssignmentTableEntity => ({
  title: savedAssignment.title as LenderAssignmentTitles,
  lenderProfileId: savedAssignment.lenderProfileId,
  userProfileId: savedAssignment.userProfileId ?? null,
  lenderProfileAssignmentTitleId: savedAssignment.lenderProfileAssignmentTitleId,
});

export const getContactsAssignmentsToSet = (
  savedAssignmentTitles: LenderProfileAssignmentTitle[],
  lenderProfileId: string
): ContactAssignmentTableEntity[] => {
  const savedAssignmentsByTitle = keyBy(savedAssignmentTitles, 'title') as Record<
    LenderAssignmentTitles,
    LenderProfileAssignmentTitle
  >;
  return Object.values(LenderAssignmentTitles).map(title => {
    const savedAssignment = savedAssignmentsByTitle[title];
    return savedAssignment
      ? formatSavedContactAssignment(savedAssignment)
      : getDefaultContactAssignment(title, lenderProfileId);
  });
};
